import { createContext, useContext, useState } from 'react'
import { CryptoPackageModal } from './CryptoPackageModal'

const CryptoPackageModalContext = createContext()
CryptoPackageModalContext.displayName = 'CryptoPaymentModalContext'

export const useCryptoPackageModal = () => useContext(CryptoPackageModalContext)

export const CryptoPackageModalProvider = ({ children }) => {
  const [showPackageModal, setShowPackageModal] = useState(false)

  const handleCloseCryptoPackageModal = () => setShowPackageModal(false)
  const handleOpenCryptoPackageModal = () => setShowPackageModal(true)

  return (
    <CryptoPackageModalContext.Provider
      value={{
        showPackageModal,
        handleOpenCryptoPackageModal,
        handleCloseCryptoPackageModal
      }}
    >
      {children}
      <CryptoPackageModal />
    </CryptoPackageModalContext.Provider>
  )
}
